<template>
  <div class="company-box">
    <div class="left">
      <img v-if="currentUserInfo.headUrl" :src="currentUserInfo.headUrl" class="avatar">
      <el-avatar v-else :size="48" icon="el-icon-user-solid"></el-avatar>
      <div class="name-box">
        <div class="name">您好，{{ currentUserInfo.nickName || currentUserInfo.name }}
          <div v-if="currentUserInfo.authenticationStatus" :class="['status-box', currentUserInfo.authenticationStatus === '1' ? 'grey' : currentUserInfo.authenticationStatus === '2' ? 'orange' : 'green']">
            <img :src="filterIdentifyStatus(currentUserInfo.authenticationStatus).img" />
            <span>{{ filterIdentifyStatus(currentUserInfo.authenticationStatus).status }}</span>
          </div>
        </div>
        <div class="welcome">欢迎来到小紫平台</div>
      </div>
    </div>
    <div class="right">
      <div @click="showVisible" class="button button-1">
        <img :src="require('@/assets/imgs/workbench/ic_switch.svg')" />
        切换
      </div>
    </div>
    <el-dialog title="切换" :visible.sync="visible" width="500px">
      <company-list :companyLists='companyLists' @refresh="refresh" @leave="visible = false" />
    </el-dialog>
  </div>
</template>
<script>
import { mapMutations } from 'vuex';
import CompanyList from '@/components/common/companyList/index.vue';
export default {
  components: {
    CompanyList,
  },
  props: {
    currentUserInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      visible: false,
      companyLists: [],
      statusList: [
        {
          status: '未认证',
          statusCode: '1',
          img: require('@/assets/ic_weirenzheng.svg'),
        },
        {
          status: '认证中',
          statusCode: '2',
          img: require('@/assets/ic_renzhengzhong.svg'),
        },
        {
          status: '已认证',
          statusCode: '3',
          img: require('@/assets/ic_yirenzheng.svg'),
        },
      ],
    };
  },
  methods: {
    ...mapMutations({
      updateUserInfo: 'UPDATE_USERINFO',
    }),
    filterIdentifyStatus (status) {
      return this.statusList.find(item => item.statusCode === status) || {};
    },
    showVisible () {
      this.companyLists = JSON.parse(this.$local.get('ownerList')) || [];
      this.visible = true;
    },
    refresh () {
      this.visible = false;
      // this.$tabs.refreshAll(true);
    },
  },
};
</script>
<style lang="scss" scoped>
.company-box {
  font-size: 14px;
  color: #1F2733;
  background-color: #ffffff;
  border-radius: 6px;
  padding: 20px;
  margin-bottom: 8px;
  display: flex;
  justify-content: space-between;
  .left {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    .avatar {
      width: 48px;
      height: 48px;
      border-radius: 50%;
    }
    .name-box {
      margin-left: 10px;
      display: inline-flex;
      flex-direction: column;
      justify-content: space-between;
      .name {
        font-size: 16px;
        font-weight: bold;
        padding-right: 15px;
        .status-box {
          margin-left: 5px;
          font-size: 12px;
          font-weight: 400;
          border-radius: 4px;
          padding: 2px 6px;
          display: inline-flex;
          align-items: center;
          > img {
            width: 12px;
            height: 12px;
            margin-right: 3px;
          }
        }
        .grey {
          background: #F2F4F7;
          color: #1F2733;
        }
        .orange {
          background: #FEFAE0;
          color: #FAB007;
        }
        .green {
          background: #E5FEEB;
          color: #38D677;
        }
      }
      .welcome {
        color: #929AA6;
      }
    }
  }
  .right {
    display: inline-flex;
    align-items: center;
    .button {
      padding: 6px 13px;
      border-radius: 4px;
      cursor: pointer;
      > img {
        width: 14px;
        height: 14px;
      }
    }
    .button-1 {
      color: #237FFA;
      background: #E2F3FE;
      margin-right: 10px;
    }
  }
}
</style>
